import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useEffectOnce } from '../../../hooks/use-effect-once';
import { FilterButton } from './components/FilterButton';
import { FilterPopover } from './components/FilterPopover';
import type { FilterLine, VyTableFilterProps } from './types';
import { getValidFilters } from './vyTableFilterUtils';

export const VyTableFilter: React.FC<VyTableFilterProps> = React.memo(
  ({ fields, onFiltersChange, defaultFilters = [] }) => {
    const anchorRef = useRef<HTMLElement | null>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [appliedFilters, setAppliedFilters] = useState<number>(0);

    useEffectOnce(() => {
      const validFilters = getValidFilters(defaultFilters);
      setAppliedFilters(validFilters.length);
    });

    useEffect(() => {
      const validFilters = getValidFilters(defaultFilters);
      setAppliedFilters(validFilters.length);
    }, [defaultFilters]);

    const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
      anchorRef.current = event.currentTarget;
      setIsOpen(true);
    }, []);

    const handleClose = useCallback(() => {
      setIsOpen(false);
    }, []);

    const handleFiltersChange = useCallback(
      (filters: FilterLine[]) => {
        const validFilters = getValidFilters(filters);
        setAppliedFilters(validFilters.length);
        onFiltersChange?.(validFilters);
      },
      [onFiltersChange],
    );

    return (
      <>
        <FilterButton onClick={handleClick} appliedFilters={appliedFilters} />
        <FilterPopover
          anchorEl={anchorRef.current}
          open={isOpen}
          onClose={handleClose}
          fields={fields}
          onFiltersChange={handleFiltersChange}
          defaultFilters={defaultFilters}
        />
      </>
    );
  },
);
